export default function VerifiedPlaces() {
  return (
    <div>
      <h1>Razones Sociales</h1>
    </div>
  );
}
